import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";
import { HTML_LANG, normalizeLanguage } from "./languages";

function updateDocumentLanguage(lng) {
  const lang = normalizeLanguage(lng);
  document.documentElement.lang = HTML_LANG[lang];
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "pt",
    fallbackLng: "pt",
    supportedLngs: ["pt"],
    load: "languageOnly",
    interpolation: { escapeValue: false },
    defaultNS: "common",
    ns: [
      "common",
      "landing",
      "account",
      "foru",
      "forujob",
      "garantias",
      "forms",
      "legalSecurityCiber",
      "legalSecurityDados",
      "legalSecurityUses",
      "legalOuvidoria",
      "legalAccountCancellation",
      "legalContratoPF",
      "legalContratoPJ",
      "legalGarantias",
    ],
  });

i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage(i18n.language);

export default i18n;
